import { render, staticRenderFns } from "./IrisCheckbox.vue?vue&type=template&id=2e583974&"
import script from "./IrisCheckbox.vue?vue&type=script&lang=ts&"
export * from "./IrisCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./IrisCheckbox.vue?vue&type=style&index=0&id=2e583974&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports